import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { CoverageSchema } from '@/services/types/coverage-types';

import { CoverageCard } from '../shared/CoverageCard';

interface MergeStepSelectionProps {
  coverages: CoverageSchema[];
  destinationId: string;
  onDestinationChange: (id: string) => void;
}

export const MergeStepSelection = ({
  coverages,
  destinationId,
  onDestinationChange,
}: MergeStepSelectionProps) => {
  return (
    <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-200">
      <div className="mb-8">
        <h2 className="text-lg font-semibold text-gray-900 mb-2">
          Select Destination Coverage
        </h2>
        <p className="text-gray-600">
          Choose which coverage should be the target for the merge. All other
          selected coverages will be merged into it and then deleted.
        </p>
      </div>

      <RadioGroup value={destinationId} onValueChange={onDestinationChange}>
        <div className="space-y-4">
          {coverages.map((coverage) => (
            <div key={coverage.id} className="flex items-start gap-4">
              <RadioGroupItem
                value={coverage.id}
                id={coverage.id}
                className="mt-4"
              />
              <Label htmlFor={coverage.id} className="flex-1 cursor-pointer">
                <CoverageCard coverage={coverage} />
              </Label>
            </div>
          ))}
        </div>
      </RadioGroup>
    </div>
  );
};
